var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.815.185a.632.632 0 0 1 .061.822l-.061.071L4.894 4l2.921 2.922a.632.632 0 0 1-.822.954l-.071-.061L4 4.894 1.078 7.815a.632.632 0 0 1-.954-.822l.061-.071L3.106 4 .185 1.078a.632.632 0 0 1 .822-.954l.071.061L4 3.106 6.922.185a.632.632 0 0 1 .893 0z",
    fill: "#587E85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagClose);
export default __webpack_public_path__ + "static/media/tag-close.83cfd48120f9fec6768081e0ccb45deb.svg";
export { ForwardRef as ReactComponent };